
class Search {
    constructor() {

        this.form = document.getElementById("search-form");
        this.modal = document.getElementById("search-modal");
        this.openButton = document.getElementById("search-open-button");
        this.closeButton = document.getElementById("search-modal--close");
        this.searchNav = document.getElementById("search-nav");
        this.searchResults = document.getElementById("search-results");
        this.searchForms = document.querySelectorAll('.search-form');

        this.bindEvents();
        this.initNavAndResults();
        this.initFormValidation();
    }

    bindEvents() 
    {
        if (this.closeButton) this.closeButton.addEventListener("click", this.closeSearchModal.bind(this));
        if (this.openButton) this.openButton.addEventListener("click", this.openSearchModal.bind(this));

        if (this.searchNav) {
            this.searchNav.addEventListener("click", (e) => {
                if (e.target.tagName === 'A') {
                    this.searchNav.querySelectorAll('a').forEach(navItem => {
                        navItem.classList.remove('active');
                    });
                    
                    e.target.classList.add('active');
    
                    this.searchResults.querySelectorAll('[data-type]').forEach(resultDiv => {
                        resultDiv.classList.remove('active');
                    });
    
                    const targetType = e.target.getAttribute('data-type');
                    const correspondingResultDiv = this.searchResults.querySelector(`[data-type="${targetType}"]`);
                    if (correspondingResultDiv) {
                        correspondingResultDiv.classList.add('active');
                    }
                }
            });
        }

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.modal.classList.contains('show')) {
                this.closeSearchModal(e);
            }
        });
    }

    initNavAndResults() {
        if (this.searchNav && this.searchResults) {
            const firstNavItem = this.searchNav.querySelector('a');
            const firstResultDiv = this.searchResults.querySelector('[data-type]');

            if (firstNavItem && firstResultDiv) {
                firstNavItem.classList.add('active');
                firstResultDiv.classList.add('active');
            }
        }
    }

    initFormValidation() {
        this.searchForms.forEach(form => {
            form.addEventListener('submit', (event) => {
                const searchInput = form.querySelector('input[type="text"], input[type="search"]');
                const errorMessage = form.getAttribute('data-msg-error') || 'Please enter at least 3 characters';
                
                if (searchInput && searchInput.value.trim().length < 3) {
                    event.preventDefault();
                    
                    searchInput.classList.add('search-input-error');
                    searchInput.focus();
                    alert(errorMessage);
                }
            });
        });
    }

    closeSearchModal(e) {
        if (this.modal) {
            this.modal.classList.remove('show');
        }
    }

    openSearchModal(e) {
        if (this.modal) {
            this.modal.classList.add('show');
        }
    }
}

const initSearch = () => {
    if (document.getElementById("search-modal")) {
        return new Search();
    }
    return null;
};

export default initSearch;

window.search = initSearch;